import React, { Component } from 'react';

import Sharer from './Sharer';

import styled from 'styled-components';
import { colors } from '../utils/colors';

import ManchetaDesktop from './ManchetaDesktop';
import Bolo3 from './Bolo3';
import Clave from './Clave';
import Copy from './Copy';
import Antetitulo from './Antetitulo';
import Titulo from './Titulo';
import Footer from './Footer';

import { data } from '../data/data';
import { titulos } from '../data/titulos';

// STYLED
// const Block = styled.div`
// 	margin: 0 auto;
// 	max-width: 650px;
// 	padding-top: 2em;
// 	padding: 1em;
//   background: ${colors.black};
// `;
const Center = styled.div`
	margin: 0 auto;
	text-align: center;
	padding-top: 2em;
	padding: 1em;
   background: ${colors.black};
`;
const Full = styled.div`
	margin: 0 auto;
	text-align: center;
	padding-top: 2em;
	padding: 1em 0 1em 0;
	position: relative;
  background: ${colors.black};
`;

const Intro = styled.div`
	margin: 0 auto;
	text-align: center;
	position: relative;
  background: ${colors.black};
  display: flex;
	justify-content: center;
	align-items: center;
	background: url("./img/fotos/baja/intro.jpg") no-repeat;
	background-position: 50% 50%;
	background-size: cover;
	background-color: ${colors.black};
`;


class Mobile extends Component {

   render() {
      return (
         <div>
            <Intro style={{height: `${this.props.height}px`}}>
            <ManchetaDesktop width={this.props.width} height={this.props.height}/>
             <div>
                <Antetitulo contenido={titulos.antetitulo.toUpperCase()} />
								<Titulo contenido={titulos.titulo.toUpperCase()} />
								<Clave contenido={titulos.subtitulo} />
                <Antetitulo contenido={titulos.texto.toUpperCase()} />
             </div>
            </Intro>
           	{data.map((x, i) => {
					return (
             <div key={'foto-' + i}>
            <Full>
              <img src={"./img/fotos/baja/" + (i + 1) + ".jpg"} alt={i + 1 + 'mov'} width="100%"/>
             </Full>
              <Center>
                <Copy contenido={`${x.body}`} />
              </Center>
           </div>
					)
				})
        }

        <Center>
            <div style={{padding: '1em'}}>
								<Clave contenido='COMPARTE'/>
								<Sharer/>	
            </div>	
            <Footer/>
        </Center>
         

         </div>
      );
   }
}

export default Mobile;



// WEBPACK FOOTER //
// ./src/components/Mobile.js